import { memo } from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useTranslation } from 'react-i18next';

import { FormItem } from 'components/shared';
import { TypeComponentTemplate } from 'api/insight';

const optionsTypes = [
  {
    label: 'survey.template.linearScale',
    id: TypeComponentTemplate?.linearScale
  },
  {
    label: 'survey.template.options',
    id: TypeComponentTemplate?.severalOptions
  },
  { label: 'survey.template.shortAnswer', id: TypeComponentTemplate?.short },
  { label: 'survey.template.paragraph', id: TypeComponentTemplate?.paragraph }
];

function SelectOptions({
  onChange,
  value
}: {
  onChange: (option: string) => void;
  value: string;
}) {
  const { t } = useTranslation('global');
  return (
    <FormItem>
      <Select
        name="textType"
        onChange={({ target }) => onChange(target?.value)}
        size="small"
        sx={{ width: '100%', textAlign: 'left' }}
        value={value}
      >
        {optionsTypes?.map(({ label, id }) => (
          <MenuItem key={id} value={id}>
            {t(label)}
          </MenuItem>
        ))}
      </Select>
    </FormItem>
  );
}

export default memo(SelectOptions);
